import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentDocCard from '../common/ParentDocCard';
import { CollectionCard } from './CollectionCard';
import CreateCollection from './CreateCollection';
import CollectionWithCsv from './CollectionWithCsv';
import CollectionWithRestApi from './CollectionWithRestApi';
import VideoBox from '../../common/custom/VideoBox';
import DocsLink from '../../common/custom/DocsLink';
import XanoCollection from '../project-on-board/XanoCollection';
import {
  COLLECTION_SOURCE_LIST,
  COLLECTION_SOURCE_DATA,
} from '../../common/utils/data_source-util';
import ParentContentCard from '../common/ParentContentCard';
import {
  AIRTABLE,
  AURORA,
  COLLECTION_SNAPSHOT,
  MARIADB,
  MS_SQL_SERVER,
  MYSQL,
  ORACLEDB,
  POSTGRESQL,
  SALESFORCE,
  SQLITE,
} from 'drapcode-constant';
import CollectionWithJson from './CollectionWithJson';
import CollectionWithPrompt from './CollectionWithPrompt';
export class CollectionDefaultPage extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selected: 'DEFAULT',
  };
  componentDidMount() {
    const { state } = this.props.location;
    if (state) {
      const { select } = state;
      this.setState({ selected: select });
    }
  }
  handleSetState = (value) => {
    this.setState({ selected: value });
  };

  renderCreateCollectionForm = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    const { selected } = this.state;
    switch (selected) {
      case 'CSV':
        return <CollectionWithCsv projectId={projectId} version={version} history={history} />;
      case 'PROMPT':
        return <CollectionWithPrompt projectId={projectId} version={version} history={history} />;
      case 'REST_API':
        return (
          <CollectionWithRestApi
            projectId={projectId}
            version={version}
            history={this.props.history}
          />
        );
      case 'JSON':
        return <CollectionWithJson projectId={projectId} version={version} history={history} />;
      case 'APP_WRITE':
        return history.push(`/data-connector/${version}/v/${projectId}/appwrite-datasource`);
      case 'XANO':
        return history.push(`/data-connector/${version}/v/${projectId}/xano-data-source`);
      case 'SUPABASE':
        return history.push(`/data-connector/${version}/v/${projectId}/supabase-datasource`);
      case 'XATA':
        return history.push(`/data-connector/${version}/v/${projectId}/xata-datasource`);
      case 'DIRECTUS':
        return history.push(`/data-connector/${version}/v/${projectId}/directus-datasource`);
      case AIRTABLE:
        return history.push(`/data-connector/${version}/v/${projectId}/airtable-datasource`);
      case SALESFORCE:
        return history.push(`/data-connector/${version}/v/${projectId}/salesforce-datasource`);
      case POSTGRESQL:
        return history.push(`/collections/${version}/v/${projectId}/create-with-postgresql`);
      case MYSQL:
        return history.push(`/data-connector/${version}/v/${projectId}/mysql-datasource`);
      case SQLITE:
        return history.push(`/collections/${version}/v/${projectId}/create-with-sqlite`);
      case MS_SQL_SERVER:
        return history.push(`/collections/${version}/v/${projectId}/create-with-ms-sql-server`);
      case ORACLEDB:
        return history.push(`/collections/${version}/v/${projectId}/create-with-oracledb`);
      case MARIADB:
        return history.push(`/collections/${version}/v/${projectId}/create-with-mariadb`);
      case AURORA:
        return history.push(`/collections/${version}/v/${projectId}/create-with-aurora`);
      case COLLECTION_SNAPSHOT:
        return (
          <CreateCollection
            projectId={projectId}
            version={version}
            history={history}
            selected={selected}
          />
        );
      default:
        return <CreateCollection projectId={projectId} version={version} history={history} />;
    }
  };

  renderCollectionSource = () => {
    const { selected } = this.state;
    return COLLECTION_SOURCE_LIST.map((source, index) => {
      const sourceData = COLLECTION_SOURCE_DATA[source];
      return (
        <CollectionCard
          key={index}
          imageUrl={sourceData.imageUrl}
          backgroundColor={sourceData.backgroundColor}
          title={sourceData.title}
          description={sourceData.description}
          projectId={this.props.projectId}
          value={sourceData.value}
          handleSetState={this.handleSetState}
          selected={selected === source}
        />
      );
    });
  };

  render() {
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-7 col-lg-7 col-sm-7 col-xs-12 drapcode">
                {this.renderCreateCollectionForm()}
              </div>
              <div className="col-md-5 col-lg-5 col-sm-5 col-xs-12 drapcode">
                <ParentContentCard
                  title={'Collection Source'}
                  icon="collection"
                  bgColor="drapcode-violet"
                >
                  {this.renderCollectionSource()}
                </ParentContentCard>
              </div>
            </div>
            <ParentDocCard>
              <h5>
                <b>Create Collection</b>
              </h5>
              <p>
                Creating a collection is the first step towards building a database in your web
                application. So, add a name of your choice and hit the create button.
              </p>
              <br />
              <DocsLink link="https://academy.drapcode.com/docs/app-collection/create-collection" />
              <br />
              <h5>
                <b>Create Child of Field</b>
              </h5>
              <p>
                Child of field in collections allows you to bind two fields of different collections
                in a parent-child relation. When data gets added in the parent field, it
                automatically gets reflected in the child field as well.
              </p>
              <br />
              <DocsLink link="https://academy.drapcode.com/docs/app-collection-fields/child-of-field/" />
              <br />
              <h4>
                <b>
                  Videos <i className="caret-right" />{' '}
                </b>
              </h4>

              <VideoBox
                videoLink="https://www.youtube.com/watch?v=fBE5NckOoro&ab_channel=DrapCode"
                imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/parentChildRelationship.jpg"
                heading="Create Child of Field View Video"
              />
            </ParentDocCard>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDefaultPage);
